<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="title_page">THE AMERICANS</h1>
<h2 class="center">The Kent Family Chronicles (Book Eight)</h2>
<h3 class="center" style="margin-top:80px;">John Jakes</h3>
<p class="center" style="margin-top:80px;"><span><img alt="logo" src="logo.jpg"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 2title_page.vue?ec6dfe0e